<div
  *ngIf="actions.length > 1; else elseBlock"
  dropdown
  placement="bottom right"
  container="body"
  class="add-new-container d-none d-lg-block"
>
  <button dropdownToggle class="add-new" type="button" container="body" placement="bottom right">
    <div class="border-block">
      <span class="icon-ic_plus"></span>
    </div>
    <div class="text-block">{{ "BUTTON.ADD_NEW" | translate }}</div>
  </button>
  <div *dropdownMenu class="dropdown-menu dropdown-menu-right custom custom-default">
    <button *ngFor="let action of actions" class="dropdown-item" (click)="openAction(action)">{{ action.title | translate }}</button>
  </div>
</div>
<ng-template #elseBlock>
  <div class="add-new-container d-none d-lg-block" *ngIf="actions.length === 1">
    <button class="add-new" [routerLink]="actions[0].routerLink" type="button" (click)="openAction(actions[0])">
      <div class="border-block">
        <span class="icon-ic_plus"></span>
      </div>
      <div class="text-block">{{ actions[0].title | translate }}</div>
    </button>
  </div>
</ng-template>
